import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntityPermissions from '../../components/EntityPermissions';
import Common from '../../utilities/common';
import ReactInterval from 'react-interval';
import { GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions, GridToolbarContainer, DataGrid, GridRowSelectionModel, GridPaginationModel, GridCallbackDetails, GridRowId } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import $ from "jquery";
import IpsTotal from './IpsTotal';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'ips' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IpsCodigosPostalesState {
    log: any[];
    progress: any;
    currentPage: number;
}

export default class IpsCodigosPostales extends React.Component<{}, IpsCodigosPostalesState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            log: [],
            progress: {},
            currentPage: 0
        }
    }

    componentDidMount(): void {
        this.GetProgress();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar} noAccessMessage='No tiene permisos para ver este contenido.'>
                <ReactInterval timeout={1000} enabled={this.state.progress.estado == 'En proceso'} callback={() => {
                    this.GetProgress();
                    this.GetLog();
                }}/>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'IPs',
                            url: '/settings/ips'
                        },
                        {
                            title: 'Códigos postales por IP',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <MarkunreadMailboxOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Códigos postales por IP
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.IPS}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        {
                            this.state.progress != null && this.state.progress.estado == 'En proceso' && (
                                <Alert severity='info' style={{marginBottom: '20px'}}>
                                    Asignación de códigos postales en proceso. Esta operación puede tardar varias horas dependiendo del nivel de ocupación del servicio.
                                </Alert>
                            )
                        }
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <IpsTotal title='Total' total={this.state.progress.total} icon={<StorageOutlinedIcon style={{fontSize: '42px', opacity: '.5'}}/>}></IpsTotal>
                            </Grid>
                            <Grid item xs={3}>
                                <IpsTotal title='Procesadas' total={this.state.progress.actual} icon={<ChecklistOutlinedIcon style={{fontSize: '42px', opacity: '.5'}}/>}></IpsTotal>
                            </Grid>
                            <Grid item xs={3}>
                                <IpsTotal title='Asignadas' total={this.state.progress.cpsAsignados} icon={<CheckCircleOutlineOutlinedIcon style={{fontSize: '42px', opacity: '.5'}}/>}></IpsTotal>
                            </Grid>
                            <Grid item xs={3}>
                                <IpsTotal title='No asignadas' total={this.state.progress.cpsNoAsignados} icon={<ErrorOutlineOutlinedIcon style={{fontSize: '42px', opacity: '.5'}}/>}></IpsTotal>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <DataGrid
                            autoHeight
                            slots={{ toolbar: CustomToolbar }}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            hideFooter={this.state.log.length <= 30}
                            rows={this.state.log}
                            columns={[
                                { field: 'ip', headerName: 'IP', width: 200 },
                                { field: 'message', headerName: 'Mensaje', width: 800}
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: this.state.currentPage, pageSize: 30 },
                                },
                            }}
                            pageSizeOptions={[30, 60, 100]}
                            checkboxSelection={false}
                            onPaginationModelChange={(model: GridPaginationModel, details: GridCallbackDetails) => {
                                this.setState({
                                    currentPage: model.page
                                });
                            }}
                        />
                    </Box>
                    <Box className='stepper'>
                        {
                            this.state.progress.estado != 'En proceso' && (
                                <div style={{textAlign: 'right'}}>
                                    <Button variant="contained">
                                        Iniciar asignación completa
                                    </Button>
                                    <Button variant="contained">
                                        Iniciar asignación incremental
                                    </Button>
                                </div>
                            )
                        }
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private GetLog(): void {
        let url = `${Common.END_POINT}/masters/ip/log`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    log: response
                }
            );
        });
    }

    private GetProgress(): void {
        let url = `${Common.END_POINT}/masters/ip/progress`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    progress: response[0]
                }
            );
        });
    }
}
